webpackJsonp([51463055290256],{

/***/ 703:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"contentfulNovica":{"id":"c3FtiQa1ph18HIZBcdBV9rn","naslov":"Začetna skupina vodene rekreacije ob nedeljah","createdAt":"2019-10-11T12:38:35.186Z","slika":{"file":{"url":"//images.ctfassets.net/0mpr9vmqs1v8/5JZgcCZMmzkOmI8tOMBwRM/8b9c3433a7f970cf4f8455de7309768c/plakatweb.jpg"},"description":""},"tekst":{"tekst":"Z novo sezono imamo tudi nov termin vodene rekreacije za odrasle. Program je namenjen začetnikom in tistim, ki že dlje časa igrate in bi se radi naučili pravilne tehnike udarcev in gibanja po igrišču. Ker se učimo, da bomo boljše igrali, je zadnji del treninga namenjen samo igri.\n\nVabljeni!\n\nZa več informacij nam lahko pišete na bklub.bit@gmail.com ali pokličete na 031 501 176 (Nina)."}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---novice-c-3-fti-qa-1-ph-18-hiz-bcd-bv-9-rn-ef489762479c9489f302.js